<template>
    <div class="news">
<!--      <first-Component></first-Component>-->
      <img class="banner animated fadeIn" src="../assets/newsB.png" alt="" id="d1">
      <div class="link animated fadeInLeft">
        <div class="main">
          <span class="title">{{$t('news.link[0]')}}</span>
          <span> - {{$t('news.link[1]')}}</span>
        </div>
      </div>
      <div class="mainCon">
        <div class="mainOne wow fadeInUp">
         <span @click="show(0)" :style="select===0?aStyle:''">{{$t('news.titleList[0]')}}</span>
          <span @click="show(1)" :style="select===1?aStyle:''">{{$t('news.titleList[1]')}}</span>
        </div>
         <p class="t wow fadeInUp">{{title}}</p>
        <span class="la wow fadeInUp"></span>
          <div class="newsMain wow fadeInUp">
            <div class="newsItem" v-for="(item,index) in newsList" :key="index"  @click="gotoNews(item.ID)">
              <img :src="`http://www.pan-am.com.cn/upload/${item.SMALLPIC}`" alt="">
              <p class="newsTitle">{{item.TITLE}}</p>
              <p class="newsContent" style="font-family: light2">{{item.TITLE2}}</p>
<!--              <p class="newsTime">{{item.NOTETIME}}</p>-->
            </div>
          </div>
        <div @click="showMore">
          <Btn-Component class="wow fadeInUp" :text="$t('btn2')"></Btn-Component>
        </div>
      </div>
      <foot-Component @gotoTop="gotoTop"></foot-Component>
    </div>
</template>

<script>
  import firstComponent from  "./first"
  import footComponent from "./foot"
  import BtnComponent from "./btn"
  import Scrollbar from 'smooth-scrollbar';
  import {getNewsUrl } from '../util/lang'
    export default {
        name: "news",
      data(){
          return{
            aStyle:{
              color:'#C9382C'
            },
            select:0,
            title:'Corporate Information',
            newsList:[],
            totalPage:'',
            page:1,
            id:'9'
          }
      },
      components:{firstComponent,footComponent,BtnComponent},
      mounted(){
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        if(this.$i18n.locale==='zh-CN'){
          this.title='公司新闻'
        }
        this.$nextTick(()=>{
          if(this.$route.query.select!==undefined){
            this.show(this.$route.query.select)
          }else{
            if(this.$i18n.locale==='en'){
              this.getNews('9')
            }else{
              this.getNews('11')
            }
          }

        })
      },
      methods:{
        showMore(){
          if(this.page<=this.totalPage){
            this.$nextTick(()=>{
              const url = `${getNewsUrl( this.$i18n.locale,this.id,1,this.page++)}`
              this.$axios.get(url).then(res => {
                this.newsList=this.newsList.concat(res.data.newsArr)
              })
            })
          }else{
            this.$notify({
              title: '提示',
              message: '已经加载全部拉',
              offset: 100
            });
          }
        },
        gotoNews(id){
          this.$router.push({path:'/newsInfo',query:{id:id}})
        },
        getNews(id){
          this.page=2
          this.id=id
            const url = `${getNewsUrl( this.$i18n.locale,id,4,1)}`
            this.$axios.get(url).then(res => {
              this.newsList=res.data.newsArr
              this.totalPage=res.data.pagerShow.totalPagers
            })
        },
          show(n){
          this.select=n
          if(this.$i18n.locale==='en')
          {
            if(n===0){
              this.title='Corporate Information'
              this.getNews(9)
            }else{
              this.title='Industry News'
              this.getNews(10)
            }
          }else {
            if(n===0){
              this.title='公司新闻'
              this.getNews(11)
            }else{
              this.title='行业新闻'
              this.getNews(12)
            }
          }

          },
        gotoTop(){
          Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#d1"))
        },
      }
    }
</script>

<style scoped>
.news{
  width:100%;
}
.banner{
  width:100%;
  display: block;
}
.link{
  width:100%;
  padding: 30px 0;
  border-bottom: 1px solid rgba(250, 250, 250, 1);
}
.link .main{
  width:1280px;
  margin: 0 auto;
  text-align: left;
}
.link .main span{
  color:#C9382C;
  text-transform: uppercase;
}
.link .main .title{
  color:black;
}
  .mainCon{
    width:1280px;
    margin: 30px auto;
  }
  .mainCon .mainOne{
    width:100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    border-bottom: 1px solid rgba(0,0,0,.1);
  }
  .mainOne span{
    display: inline-block;
    padding: 20px 60px;
    font-size: 20px;
    font-weight: bold;
    position: relative;
    cursor: pointer;
    transition: all 2s;
  }
 .mainOne span::before{
   content: '';
   position: absolute;
   bottom:0;
   left:20%;
   width:0;
   background-color: #C9382C;
   height:2px;
   transition: all 2s;
 }
.mainOne span:hover{
  color:#C9382C;
}
.mainOne span:hover::before{
  width:60%;
}
.t{
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    transition: all 2s;
    margin-top: 60px;
    margin-block-end: 0em;
    text-transform: uppercase;
  }
  .la{
    width:35px;
    height:3px;
    margin: 0 auto;
    background-color: #C9382C;
    display: inline-block;
  }
.t:hover{
  color:#C9382C;
}
.newsMain{
  width:1280px;
  margin: 60px auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.newsItem{
  width:20%;
  margin-left: 4%;
  overflow: hidden;
  cursor: pointer;
  padding-bottom: 10px;
  margin-top: 30px;
  position: relative;
}
.newsItem img{
  width:100%;
  transition: all 2s;
}
.newsItem p{
  text-align: left;
  line-height: 25px;
  padding-left: 5%;
  padding-right: 5%;
  transition: all 2s;
}
.newsTitle{
  font-weight: bold;
  font-size: 15px;
}
.newsContent{
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
-webkit-box-orient: vertical;
}
.newsTime{
  font-weight: bold;
  font-size: 12px;
}
.newsItem::before{
  display: inline-block;
  content: '';
  width:0;
  height:2px;
  background-color: #C9382C;
  transition: all 2s;
  position: absolute;
  bottom:0;
  left:0;
}
.newsItem:hover::before{
  width:100%;
}
  .newsItem:hover img{
    transform: scale(1.1);
  }
.newsItem:hover p{
  color:#C9382C;
}
@media screen and (max-width:450px){
  .banner{
    height:100vh;
    object-fit: cover;
  }
  .news{
    overflow: hidden;
  }
  .link .main{
    width:90%;
    margin-left: 5%;
  }
  .mainCon{
    width:100%;
  }
  .mainOne span{
    display: inline-block;
    padding: 20px 20px;
  }
  .newsMain{
    width:90%;
    display: flex;
    flex-direction: column;
    margin-left: 5%;
  }
  .newsItem{
    width:100%;
    margin-left: 0;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue